import { render, staticRenderFns } from "./WidePanel.vue?vue&type=template&id=49ea6b27&"
import script from "./WidePanel.vue?vue&type=script&lang=js&"
export * from "./WidePanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports